import React from "react";
import { Button } from "@mui/material";
import { FaPlus } from "react-icons/fa6";

const AddButton = ({
    label = "Adicionar",
    fullWidth = false,
    disabled = false,
    fullHeight = false,
    onClick,
    variant = "outlined"
}) => {
    return (
        <Button
            variant={variant}
            color="primary"
            endIcon={<FaPlus style={{ fontSize: '12px' }} />}
            onClick={onClick}
            fullWidth={fullWidth}
            disabled={disabled}
            sx={{ height: fullHeight ? "100%" : undefined }}
            type="button"
            size="small"
        >
            {label}
        </Button>
    );
}

export default AddButton;
